import api from '@/lib/axios';

import type { PaginatedResponse } from '@/types/tenant';
import type {
  CreateDocumentTypePayload,
  DocumentTypeDto,
  UpdateDocumentTypePayload,
} from '@/types/documentType';
import type { ListFilterPayload } from '@/types/filters';

// ============================================
// Query Params
// ============================================

interface GetDocumentTypesParams {
  page?: number;
  size?: number;
  sort?: string;
}

// ============================================
// Document Types CRUD
// ============================================

export const getDocumentTypes = async (
  params: GetDocumentTypesParams = {},
  body?: ListFilterPayload,
): Promise<PaginatedResponse<DocumentTypeDto>> => {
  const response = await api.post<PaginatedResponse<DocumentTypeDto>>(
    '/platform-service/v1/document-types/list',
    body ?? {},
    { params },
  );
  return response.data;
};

export const getDocumentTypeById = async (
  id: string,
): Promise<DocumentTypeDto> => {
  const response = await api.get<DocumentTypeDto>(
    `/platform-service/v1/document-types/${id}`,
  );
  return response.data;
};

export const createDocumentType = async (
  data: CreateDocumentTypePayload,
): Promise<DocumentTypeDto> => {
  const response = await api.post<DocumentTypeDto>(
    '/platform-service/v1/document-types',
    data,
    { successToast: true },
  );
  return response.data;
};

export const updateDocumentType = async (
  id: string,
  data: UpdateDocumentTypePayload,
): Promise<DocumentTypeDto> => {
  const response = await api.put<DocumentTypeDto>(
    `/platform-service/v1/document-types/${id}`,
    data,
    { successToast: true },
  );
  return response.data;
};

export const deleteDocumentType = async (id: string): Promise<void> => {
  await api.delete(`/platform-service/v1/document-types/${id}`, { successToast: true });
};
